export const aboutUsSliderOptions = (instance, options) => {

    let responsiveItemCounts = {
        1000: 4,
        699: 2,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
            spaceBetween: 24,
            cssMode: false,
        }
    }

    return {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        cssMode: false,
        breakpoints: breakpoints,
    }
}